import React, { useState } from 'react';

import { check } from '@/assets/icons';
import { BottomCard, BottomCardAction } from '@/components/shared/BottomCard';
import { AsaphButton } from '@/components/shared/Button';
import { Label } from '@/components/shared/Inputs/Label';
import {
	SettingsList,
	SettingsListItems,
} from '@/components/shared/SettingCard';
import { DefaultKeys } from '@/config/constants';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { useTeamSongs } from '@/providers/TeamSongsProvider';
import { SvgIcon } from '@material-ui/core';

import { SongOverride } from '../../GenerateSetlist';
import styles from './DefaultKeyBottomCard.module.scss';

interface DefaultKeyBottomCardProps {
	teamSongId: string;
	songOverrides: SongOverride[];
	onSave: (defaultKey: string) => void;
	onClose: () => void;
}

export const DefaultKeyBottomCard: React.FC<DefaultKeyBottomCardProps> = ({
	teamSongId,
	songOverrides,
	onSave,
	onClose,
}) => {
	const { findTeamSongsById } = useTeamSongs();
	const teamSong = findTeamSongsById([teamSongId])[0];
	const songOverride = songOverrides.find(
		(override) => override.id === teamSongId,
	);
	const [selectedKey, setSelectedKey] = useState<string>(
		songOverride?.defaultKey || teamSong?.defaultKey || DefaultKeys[0],
	);
	const fireSaveDefaultKeyEvent = useAnalyticsEvent(
		'Generate_Setlist_Save_Default_Key',
	);

	const keyItems: SettingsListItems = DefaultKeys.map((key) => ({
		type: 'setting' as const,
		title: key,
		trailingComponent:
			key === selectedKey ? (
				<div className={styles['key-check--selected']}>
					<SvgIcon component={check} />
				</div>
			) : undefined,
		onClick: () => {
			setSelectedKey(key);
		},
	}));

	const handleSave = () => {
		fireSaveDefaultKeyEvent();
		onSave(selectedKey);
	};

	if (!teamSong) {
		onClose();
		return null;
	}

	return (
		<BottomCard
			title="Change Key"
			hasCloseButton={true}
			closeButtonLabel="Cancel"
			onClose={onClose}
		>
			<div className={styles['root']}>
				<Label className={styles['label']}>
					Change key for{' '}
					<span className={styles['song-name']}>{teamSong.name}</span>
				</Label>
			</div>
			<div className={styles['list-wrapper']}>
				<SettingsList items={keyItems} />
			</div>
			<BottomCardAction>
				<AsaphButton
					onClick={handleSave}
					fullWidth
					label="Save"
					color="blue"
				/>
			</BottomCardAction>
		</BottomCard>
	);
};
